<template>
  <div class="intro-container">
    <div class="breadcrumb-section">
      <div class="intro-card">
        <el-breadcrumb separator="/" style="margin-bottom: 20px">
          <el-breadcrumb-item :to="{ path: '/pc/mall' }">商城首页</el-breadcrumb-item>
          <el-breadcrumb-item>店铺资质</el-breadcrumb-item>
        </el-breadcrumb>
        <h2 class="main-title">因朔桔商城</h2>
        <p class="desc">注：以下信息，由商家依据《电子商务法》规定发布公示。如需进一步核实，可联系商家客服咨询</p>
        <div class="table-section">
          <table class="info-table">
            <tr>
              <td>公司名称：</td>
              <td>广东邦健医药连锁有限公司</td>
            </tr>
            <tr>
              <td>统一信用代码：</td>
              <td>914412007993211620</td>
            </tr>
            <tr>
              <td>法定代表人：</td>
              <td>陈勇前</td>
            </tr>
            <tr>
              <td>注册资本：</td>
              <td>人民币壹亿壹仟肆佰伍拾伍万陆仟贰佰伍拾伍元</td>
            </tr>
            <tr>
              <td>成立日期：</td>
              <td>2007年03月08日</td>
            </tr>
            <tr>
              <td>公司类型：</td>
              <td>有限责任公司（非自然人投资或控股的法人独资）</td>
            </tr>
            <tr>
              <td>注册地址：</td>
              <td>肇庆市端州区睦岗街道过境公路（肇庆大道北侧）03区邦健园区办公大楼第一层至第八层，办公大楼副楼第三层</td>
            </tr>
            <tr>
              <td>登记机关：</td>
              <td>肇庆市端州区市场监督管理局</td>
            </tr>
            <tr>
              <td>营业期限：</td>
              <td>2025年06月11日</td>
            </tr>
            <tr>
              <td>经营范围：</td>
              <td class="wrap-text">药品零售；食品销售；保健食品、化妆品、日用品销售；医疗器械销售等（详见营业执照原文）</td>
            </tr>
          </table>
        </div>
        <div class="img-section">
          <div class="img-block">
            <div class="img-desc">营业执照</div>
            <img class="intro-img" :src="require('@/assets/img/mall/yingyezhizhao.png')" alt="营业执照" />
          </div>
          <div class="img-block">
            <div class="img-desc">医疗器械经营许可证<span style="font-size: 14px; color: #666; margin-left: 20px">资质编号：粤肇药监械经营 许20240160号</span></div>
            <img class="intro-img" :src="require('@/assets/img/mall/xukezheng.png')" alt="医疗器械经营许可证" />
          </div>
        </div>
      </div>
    </div>
    <footer-layout></footer-layout>
  </div>
</template>

<script>
export default {
  name: 'ShopIntro'
}
</script>

<style scoped>
.intro-container {
  background: #fafafa;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 0;
}
.intro-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px #0000000a;
  padding: 40px 60px;
  min-width: 900px;
  max-width: 1100px;
  margin: 0 auto;
  text-align: left;
}
.main-title {
  text-align: left;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 10px;
}
.desc {
  color: #888;
  margin: 10px 0 30px 0;
  text-align: left;
}
.table-section {
  margin-bottom: 20px;
}
.info-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  font-size: 16px;
}
.info-table td {
  border: 1px solid #eee;
  padding: 10px 16px;
  color: #333;
  text-align: left;
  vertical-align: top;
  word-break: break-all;
}
.info-table td:first-child {
  background: #fafbfc;
  font-weight: bold;
  width: 160px;
  color: #666;
}
.wrap-text {
  white-space: pre-line;
  word-break: break-all;
}
.qualification {
  margin: 20px 0 30px 0;
  font-size: 16px;
  color: #333;
  font-weight: bold;
  text-align: left;
}
.img-section {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: flex-start;
}
.img-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.intro-img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px #0001;
  margin-bottom: 8px;
}
.img-desc {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin: 20px 10px;
}
</style>
